<template>
    <div>
        <el-tabs v-model="platform">
            <el-tab-pane label="Zoom会议" name="zoom" v-if="hasZoom">
            </el-tab-pane>
            <el-tab-pane label="腾讯会议" name="tencent" v-if="hasTencent">
            </el-tab-pane>
            <el-tab-pane label="Welink" name="welink" v-if="hasWelink">
            </el-tab-pane>
        </el-tabs>
        <!-- 显示会议 -->
        <el-row class="meeting-dayview" :loading="process.loading">

            <!-- 显示头部 日期选择以及时间 -->
            <div class="header_row" style="height: 80px;">
                <div class="calendar-left" style="padding-bottom: 0">
                    <div class="calendar-district">
                        <div>
                            <el-date-picker
                                style="width: auto"
                                size="medium"
                                v-model="target"
                                value-format="yyyy-MM-dd"
                                type="date"
                                @change="reload"
                                placeholder="选择日期">
                            </el-date-picker>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <el-button type="default" style="padding: 4px 25px;" size="medium"
                                       @click.native='previous' icon="el-icon-arrow-left">
                            </el-button>
                            <el-button type="default" style="padding: 4px 25px;" size="medium"
                                       icon="el-icon-arrow-right"
                                       @click.native='next'>

                            </el-button>
                        </div>
                    </div>
                </div>

                <div class="calender-right" :style="{overflow:'hidden'}" ref="headerRule">
                    <div class="wrapper" :style="{width:calendarWidth}">
                        <div class="rule">
                            <div class="relative">
                                <div class="calender-heading-trow" :style="{width:calendarWidth}">
                                    <div class="cell" v-for="cell in ruleCells" :key="cell"
                                         :style="{width:cell_width + 'px'}">
                                        <div class="hour-text">{{ cell }}
                                            <div class="minutes">
                                                <div><span>00</span></div>
                                                <div><span>30</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

            <!-- 显示主体部分  -------------------------------------------------------------->
            <div class="body-row-for-scroll" style="max-height: calc(100vh - 300px); overflow:auto">
                <div class="body-row">
                    <div class="calendar-left" style="position: relative;padding-bottom: 0">
                        <div id="meetingroom_room_list">
                            <template v-if="platform==='zoom'">
                            <div class="calender-trow-room" v-for="room in meetingRooms" :key="'RoomId_'+room.id">
                                <div class="name"> {{ room.name }}
                                    <div class="group">{{ room.group_name }}</div>
                                    <div class="address">{{ room.email }}</div>
                                </div>
                            </div>
                            </template>
                            <template v-if="platform==='tencent'">
                                <div class="calender-trow-room" v-for="(room,k) in tencent" :key="'RoomId_'+k">
                                    <div class="name"> {{ k == 0? '腾讯会议室' : parseInt(k) + 1 }} </div>
                                </div>
                            </template>
                            <template v-if="platform==='welink'">
                                <div class="calender-trow-room" v-for="(room,k) in welink" :key="'RoomId_'+k">
                                    <div class="name"> {{ k == 0? 'Welink' : parseInt(k) + 1 }} </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- calendar -->
                    <div class="calender-right" style="overflow: hidden;" ref="bodyContent">
                        <div class="wrapper" :style="{width:calendarWidth}">
                            <div class="rule" id="meetingroom_scroll_area">
                                <div class="relative">
                                    <!--  分会议室 制作表格 -->
                                    <div style="position: relative;" class="calender-meeting">
                                        <div class="calender-body-trow"
                                             v-for="room in platform==='zoom'?books:(platform==='tencent'?tencent:welink)" :key="room.id">
                                            <div class="cell" v-for="cell in ruleCells" :key="cell"
                                                 :style="{width:cell_width + 'px'}">
                                                <div class="time-slot">
                                                </div>
                                            </div>
                                            <!-- Meeting List -->
                                            <div class="meeting"
                                                 v-for="resv in room.reserves"
                                                 :class="resv.approve === '1'?'submitted':'approved'"
                                                 :key="resv.id"
                                                 :style="{left:calcPosition(resv.meeting_date,resv.meeting_time,resv.duration).left,width:calcPosition(resv.meeting_date,resv.meeting_time,resv.duration).width}"
                                            >
                                                <el-popover placement="top" trigger="click">
                                                    <div class="meeting-popover">
                                                        <div class="meeting-inner">
                                                            <div class="name text-info">
                                                                ({{ resv.id }}){{ resv.host_name }}
                                                            </div>
                                                            <div class="time mt-1">{{resv.meeting_date === today?'':resv.meeting_date}}{{ resv.meeting_time }} -
                                                                {{ resv.meeting_end }}
                                                            </div>
                                                            <div class="department mt-1">{{ resv.department }}</div>
                                                            <div class="author mt-1">{{ resv.topic }}</div>
                                                            <div class="author mt-1">{{ resv.meeting_id }}</div>
                                                            <div class="author mt-2 ">
                                                                {{ resv.approve === '1' ? '提交' : '批准' }}
                                                                <span
                                                                    class="text-danger"> {{ resv.option_h323 === '1' ? '使用H.323' : '' }} </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="meeting-inner" slot="reference">
                                                        <div class="name">{{ resv.host_name }}</div>
                                                        <div class="time">{{ resv.meeting_time }} -
                                                            {{ resv.meeting_end }}
                                                        </div>
                                                        <div class="department">{{ resv.department }}</div>
                                                        <div class="author">{{ resv.topic }}</div>
                                                        <div class="h323" v-if="resv.option_h323=='1'"><i class="fa fa-circle"></i>
                                                        </div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
            <!-- footer ----------------------------------------------------------------------------------------------->
            <div class="body-row-for-scroll" style="max-height: calc(100vh - 300px); overflow:auto">
                <div class="body-row">
                    <div class="calendar-left" style="position: relative;height: 1px;">
                    </div>
                    <!-- calendar -->
                    <div class="calender-right" @scroll="syncHeader">
                        <div class="wrapper" :style="{width:calendarWidth,height:'1px'}">
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </el-row>
    </div>

</template>

<script>

import dayView from "../common/mixins/meeting-dayview";

export default {
    name: "meeting-dayview",
    mixins: [dayView],
}
</script>

<style scoped lang="scss">
@import "../common/scss/dayview";
</style>
